<!--suppress ALL -->

<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Văn bản đi đã ban hành
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div
                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"
                    >
                      <span class="label-input width__auto"
                      >Ngày văn bản:
                      </span>
                      <el-date-picker
                        v-model="docDateRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        @change="filterByDocDateRange"
                      >
                      </el-date-picker>
                    </div>
                  </template>
                  <template #advance>
                    <dabanhanh-advance-search
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    STT
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'"/>
                  </div>
                </div>
                <div class="rightSection flex-row flex__right ">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left clickable"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left clickable"
                    @click="doSort('createTime')"
                  >
                    Ngày tạo
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'createTime'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in outgoingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between clickable"
                    @click="viewDetailDocs(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>
                          <i
                            class="fas fa-file color__silver"
                            @click.stop="
                              downloadAttachment(
                                item,
                                ATTACHMENT_OBJECT_TYPE.VB_DI
                              )
                            "
                          ></i>
                        </div>
                      </div>
                      <div class="theTitle__lv1 margin-right-10">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">{{ item.quote }}</div>
                          <div class="tt_2 flex-row flex__left">
                            <span v-if="item.docCode"
                            >{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                            </el-tag>

                            <el-tag
                              v-if="isShowPiority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <i class="fas fa-bolt"></i>
                              <span>
                                {{ item.priorityName }}
                              </span>
                            </el-tag>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i
                            class="cellIcon color__silver fas fa-file-import"
                          ></i>
                          {{
                          item.docDate
                          | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                          })
                          }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-clock"></i>
                          {{
                          item.createTime | dateFormatter({ nullValue: "-" })
                          }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                    force-use-infinite-wrapper=".el-table__body-wrapper"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
    </template>
  </listTemplate>
</template>
<script>
  import InfiniteLoading from "vue-infinite-loading";
  import outGoingDocSevice from "../../services/outgoingDocService";
  import dateFormatter from "../../filters/dateFormatter";
  import constants from "../../constants";
  import utils from "../../services/utils";
  import listTemplate from "../common/list";
  import headerTemplate from "../../components/header/main-header.vue";
  import searchTemplate from "../common/search";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import {EventBus} from "../../event-bus.js";
  import dateUtils from "../../dateUtils";
  import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
  import buildAttachmentURL from "../../filters/buildAttachmentURL";
  import DabanhanhAdvanceSearch from "./components/dabanhanh-advance-search";

  export default {
    components: {
      DabanhanhAdvanceSearch,
      InfiniteLoading,
      listTemplate,
      headerTemplate,
      searchTemplate,
      VuePerfectScrollbar,
      subHeader: () => import("../../components/main/sub-header.vue"),
      SortCaret: () => import("./SortCaret")
    },

    mixins: [vbAttachmentTokenMixin],

    filters: {dateFormatter, buildAttachmentURL},

    data() {
      return {
        ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
        dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
        isOpenAdvanceSearchDialog: false,
        isEnableAdvanceSearchDialog: false,
        perfectScrollbarSetting: {maxScrollbarLength: 350},

        outgoingDocs: [],

        page: 0,
        size: 10,
        advanceSearchForm: {},
        sort: null,
        order: null,
        keyword: null,
        docDateRange: [null, null]
      };
    },

    mounted() {
      EventBus.$on(this.currentRoute, options => {
        this.doSearch();
      });
    },

    computed: {
      currentRoute() {
        return this.$route.path.split("/")[3];
      },
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      }
    },

    watch: {
      isOpenDialogCreate: function (newValue) {
        newValue && (this.isEnableDialogCreate = newValue);
      },
      isOpenAdvanceSearchDialog: function (newValue) {
        newValue && (this.isEnableAdvanceSearchDialog = newValue);
      }
    },

    created() {
      this.initQuery();
    },

    methods: {
      initQuery() {
        this.sort = this.$route.query.sort || "updateTime";
        this.order = this.$route.query.order || "desc";
        this.advanceSearchForm = {
          keyword: this.$route.query.keyword || undefined,
          fromDocDate: this.$route.query.fromDocDate
            ? parseInt(this.$route.query.fromDocDate)
            : undefined,
          toDocDate: this.$route.query.toDocDate
            ? parseInt(this.$route.query.toDocDate)
            : undefined,
          docCode: this.$route.query.docCode || undefined,
          quote: this.$route.query.quote || undefined,
          fileContent: this.$route.query.fileContent || undefined,
          docTypeId: this.$route.query.docTypeId || undefined,
          bookId: this.$route.query.bookId || undefined,
          otherReceivePlaces: this.$route.query.otherReceivePlaces || undefined,
          receiveDeptId: this.$route.query.receiveDeptId || undefined
        };
        this.keyword = this.advanceSearchForm.keyword;
        this.initDocDateRange();
      },

      buildQuery() {
        return utils.merge(
          {sort: this.sort || "updateTime", order: this.order || "desc"},
          this.advanceSearchForm
        );
      },

      initDocDateRange() {
        if (
          this.advanceSearchForm.fromDocDate ||
          this.advanceSearchForm.toDocDate
        ) {
          this.docDateRange = [
            dateUtils.toMoment(this.advanceSearchForm.fromDocDate),
            dateUtils.toMoment(this.advanceSearchForm.toDocDate)
          ];
        } else {
          this.docDateRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
          );
          let defaultTimeRange = dateUtils.getTimesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
          );
          this.advanceSearchForm.fromDocDate = defaultTimeRange[0];
          this.advanceSearchForm.toDocDate = defaultTimeRange[1];
        }
      },

      simpleSearch(keyword) {
        this.keyword = this.advanceSearchForm.keyword = keyword;
        this.advanceSearchForm.docCode = undefined;
        this.advanceSearchForm.quote = undefined;
        this.advanceSearchForm.fileContent = undefined;
        this.advanceSearchForm.docTypeId = undefined;
        this.advanceSearchForm.bookId = undefined;
        this.advanceSearchForm.receiveDeptId = undefined;
        this.advanceSearchForm.otherReceivePlaces = undefined;
        this.doSearch();
      },

      filterByDocDateRange() {
        this.advanceSearchForm.fromDocDate =
          this.docDateRange && this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined;
        this.advanceSearchForm.toDocDate =
          this.docDateRange && this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined;
        this.doSearch();
      },

      advanceSearch(event) {
        let advanceSearchForm = event.advanceSearchForm;
        this.advanceSearchForm.keyword = undefined;
        this.keyword = null;
        this.advanceSearchForm.priorityId =
          advanceSearchForm.priorityId || undefined;
        this.advanceSearchForm.docCode = advanceSearchForm.docCode || undefined;
        this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
        this.advanceSearchForm.fileContent =
          advanceSearchForm.fileContent || undefined;
        this.advanceSearchForm.docTypeId =
          advanceSearchForm.docTypeId || undefined;
        this.advanceSearchForm.bookId = advanceSearchForm.bookId || undefined;
        this.advanceSearchForm.receiveDeptId =
          advanceSearchForm.receiveDeptId || undefined;
        this.advanceSearchForm.otherReceivePlaces =
          advanceSearchForm.otherReceivePlaces || undefined;
        this.doSearch();
      },

      doSort(sort) {
        this.sort = sort;
        this.order =
          sort == this.sort ? (this.order == "asc" ? "desc" : "asc") : "asc";
        this.doSearch();
      },

      doSearch() {
        this.$router.replace({
          name: this.$router.name,
          params: this.$route.params,
          query: this.buildQuery()
        });
        this.outgoingDocs = [];
        this.page = 0;
        this.$nextTick(() => this.$refs.infiniteLoading.stateChanger.reset());
      },

      infiniteHandler($state) {
        this.list().then(items => {
          this.page += 1;
          items && items.length ? $state.loaded() : $state.complete();
        });
      },

      list() {
        let pageable = {
          page: this.page,
          size: this.size,
          sort: [this.sort, this.order].join(",")
        };

        let advanceSearchForm = utils.merge(this.advanceSearchForm, {
          status: constants.OUTGOING_DOC_STATUS.DABANHANH
        });

        return outGoingDocSevice
          .listChoBanHanh2(advanceSearchForm, pageable)
          .then(response => {
            let items = response.data;
            items && this.outgoingDocs.push(...items);
            return items;
          });
      },

      getPiorityClass(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
          ? "lv1"
          : "lv4";
      },

      isShowPiority(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
      },

      viewDetailDocs(item) {
        item.isSeen = 1;
        this.$router.push({
          name: "vbDaBanHanhDetail",
          params: {userDeptRoleId: this.userDeptRoleId, id: item.id},
          query: this.$route.query
        });
      }
    }
  };
</script>
<style scoped>
  #searchBox {
    position: relative;
    width: 100%;
  }

  .advance-search {
    font-size: 17px;
    color: #005eb1;
    position: absolute;
    right: 5%;
    top: 50%;
    transform: translateY(-50%);
  }

  .icon-very__small {
    height: 14px;
    padding-top: 4px;
  }

  .icon-info {
    background-color: #f0c330;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    margin-top: -1px;
    margin-left: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/VbDaBanHanhIndex.vue